document.addEventListener('DOMContentLoaded', function() {
	const progressBar = document.querySelector('.hero-swiper .autoplay-progress');
	const heroSwiper = new Swiper('.hero-swiper', {
		slidesPerView: "auto",
		spaceBetween: 0,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		autoplay: {
			delay: 10000,
			disableOnInteraction: false
		},
		//autoplay: false,
		speed: 500,
		on: {
			autoplayTimeLeft(s, time, progress) {
				progressBar.style.width = ((1 - progress) * 100) + "%";
			}
		}
	});

	if (document.querySelectorAll('.hero-swiper').length > 0) {
		window.onmousemove = e => {
			traceMouse(e)
		}
	}
});

function traceMouse(e) {
	const mouseX = e.clientX,
		mouseY = e.clientY;
	
	if (e.target.closest('.swiper-button')) {
		let button = e.target.closest('.swiper-button');
		let direction = button.dataset.direction;
		let span = button.querySelector('span');
		let y = (mouseY - 6 + window.scrollY);
		let x = (direction == 'prev') ? (mouseX + 10) : (mouseX - span.clientWidth - button.offsetLeft - 3);

		span.animate({
			top: y + 'px',
			left: x + 'px'
		}, {
			duration: 50,
			fill: "forwards",
			easing: "ease-in-out"
		});
	}
}

document.querySelector('.hero-swiper')?.addEventListener('click', function(e) {
	if (e.target.closest('.swiper-button')) {
		e.preventDefault();
	
		const swiper = document.querySelector('.swiper').swiper;

		if (e.target.closest('.swiper-button').dataset.direction == "prev")
			swiper.slidePrev();
		else
			swiper.slideNext();
	}
	
});